import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from "@angular/core";
import { Subscription } from "rxjs";
import { DashboardMenuTabSelectorService } from "../dashboardCommon/services/dashboardMenuTabSelector.service";
import { TabEntry } from "./tabEntry";

@Component({
    selector: 'dashboard-mobile-menu',
    templateUrl: './dashboardMobileMenu.component.html',
    standalone: false
})
export class DashboardMobileMenuComponent implements OnInit, OnDestroy {
    public selectedTab: number;
    private selectedTabChangedSubscription: Subscription;

    @Output() onOptionSelected: EventEmitter<number> = new EventEmitter();

    constructor(private selectorService: DashboardMenuTabSelectorService) {
    }

    @Input()
    public tabEntries: TabEntry[];

    public ngOnInit(): void {
        this.selectedTabChangedSubscription = this.selectorService.selectedTabChanged.subscribe((index) => this.selectedTab = index);
    }

    public ngOnDestroy(): void {
        if (this.selectedTabChangedSubscription) this.selectedTabChangedSubscription.unsubscribe();
    }

    public onSelectTab(index: number): void {
        this.selectorService.selectedTab = index;
        window.scroll(0, 0);
        this.onOptionSelected.emit(index);
    }
}